<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">
        <button
          *ngIf="!isList && !showProductsGrid"
          routerLink="/catalogs"
          title="{{ 'inputs.back' | translate }}"
          mat-icon-button
        >
          <mat-icon>keyboard_backspace</mat-icon>
          {{ "inputs.back" | translate }}
        </button>

        <h1 *ngIf="isList">{{ "titles.list.catalogue" | translate }}</h1>
        <h1 *ngIf="!isList">{{ "titles.edit.catalogue" | translate }}</h1>
        <div *ngIf="!isList && !isNew && !showProductsGrid">
          {{ "inputs.creation_date" | translate }}:
          {{ creation_date | date: "d/M/Y, H:mm:ss" }} <br />
          {{ "inputs.modification_date" | translate }}:
          {{ modification_date | date: "d/M/Y, H:mm:ss" }}
        </div>

        <div class="media-body">
          <mat-form-field *ngIf="isList">
            <mat-label>{{ "inputs.search" | translate }}</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="{{ 'inputs.search' | translate }}"
              #input
            />
          </mat-form-field>
          <div *ngIf="isList">
            <table mat-table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "tables.name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                >
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  {{ "tables.description" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                  fxHide.lt-sm
                >
                  {{ element.description }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modification_date">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  {{ "tables.modification_date" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                  fxHide.lt-sm
                >
                  {{ element.modification_date | date: "yyyy-MM-dd H:mm:ss" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.actions" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- <button mat-icon-button matTooltip="Click to Delete related information" class="iconbutton"
                  (click)="delete(element.id)" color="warn">
                  <mat-icon>delete</mat-icon>
                </button> -->
                  <button mat-icon-button
                  matTooltip="{{ 'buttons.delete' | translate }}"
                  (click)="deleteCatalogue(element.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    matTooltip="{{ 'inputs.edit' | translate }}"
                    (click)="goTo(element.id)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    matTooltip="{{ 'buttons.duplicate_catalogue' | translate }}"
                    (click)="goDuplicateCatalogue(element.id)"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  <span *ngIf="showCatalogsProgressBar">{{
                    "tables.loading" | translate
                  }}</span>
                  <span *ngIf="!showCatalogsProgressBar">{{
                    "tables.no_data_found" | translate
                  }}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar
              *ngIf="showCatalogsProgressBar"
              mode="indeterminate"
            ></mat-progress-bar>

            <mat-paginator
              [aria-label]="pepe"
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="[100, 10, 20, 50]"
              showFirstLastButtons
            ></mat-paginator>
          </div>

          <!-- <mat-card *ngIf='!isList'> -->
          <div
            class="contenedor"
            [formGroup]="catalogueForm"
            *ngIf="!isList && !showProductsGrid"
          >
            <input
              matInput
              [hidden]="true"
              [formControlName]="'id'"
              type="text"
              placeholder="id"
            />
            <mat-form-field>
              <input
                matInput
                required
                [formControlName]="'name'"
                type="text"
                placeholder="{{ 'inputs.name' | translate }}"
              />
            </mat-form-field>
            <mat-form-field>
              <textarea
                matInput
                required
                [formControlName]="'description'"
                type="text"
                placeholder="{{ 'inputs.description' | translate }}"
              ></textarea>
            </mat-form-field>
            <mat-form-field style="max-width: 150px">
              <input
                matInput
                [formControlName]="'value_shipping'"
                autocomplete="off"
                type="number"
                placeholder="{{ 'inputs.value_shipping' | translate }}"
              />
            </mat-form-field>

            <mat-form-field style="max-width: 150px">
              <input
                matInput
                required
                [formControlName]="'shipping_tax'"
                autocomplete="off"
                type="number"
                placeholder="{{ 'inputs.shipping_tax' | translate }}"
              />
            </mat-form-field>

            <mat-checkbox [formControlName]="'no_shipping'" [color]="'primary'"
              >{{ "inputs.no_shipping" | translate }}
            </mat-checkbox>
            <mat-form-field *ngIf="catalogueForm.value.no_shipping">
              <input
                matInput
                required
                [formControlName]="'no_shipping_txt'"
                type="text"
                placeholder="{{ 'inputs.no_shipping_txt' | translate }}"
              />
            </mat-form-field>
            <mat-form-field *ngIf="catalogueForm.value.no_shipping">
              <input
                matInput
                required
                [formControlName]="'no_shipping_txt_cat'"
                type="text"
                placeholder="{{ 'inputs.no_shipping_txt_cat' | translate }}"
              />
            </mat-form-field>
            <mat-form-field *ngIf="catalogueForm.value.no_shipping">
              <input
                matInput
                required
                [formControlName]="'no_shipping_txt_en'"
                type="text"
                placeholder="{{ 'inputs.no_shipping_txt_en' | translate }}"
              />
            </mat-form-field>
            <!-- </mat-card> -->
          </div>
          <div
            *ngIf="!isList && !showProductsGrid && !isNew"
            class="products-table-header"
          >
            <span>{{ "inputs.products" | translate }}</span>
            <button
              *ngIf="!isList && !showProductsGrid && !isNew"
              mat-flat-button
              (click)="showProductsGrid = !showProductsGrid"
            >
              <mat-icon>add</mat-icon>
              <span>{{ "buttons.add_products" | translate }}</span>
            </button>
          </div>

          <!-- PRODUCT ORDER TABLE -->

          <div *ngIf="!isList && !showProductsGrid && !isNew">
            <table
              mat-table
              #table
              [dataSource]="selectedProductsList"
              class="mat-elevation-z8 products-table"
              cdkDropList
              [cdkDropListData]="selectedProductsList"
              (cdkDropListDropped)="drop($event)"
            >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.name" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.name_es }}
                </td>
              </ng-container>

              <form [formGroup]="productValueForm">
                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "tables.value" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      *ngIf="editValueState.id != element.id"
                      mat-flat-button
                      (click)="
                        editProductValue(element.id, 'open', element.value)
                      "
                      class="value-button"
                    >
                      {{ element.value }}
                    </button>

                    <mat-form-field
                      appearance="outline"
                      style="width: 50%; margin-top: 8px"
                      *ngIf="editValueState.id == element.id"
                    >
                      <input
                        matInput
                        [formControlName]="'value'"
                        type="number"
                        class="hiddeArrow"
                      />
                      <button
                        type="button"
                        mat-icon-button
                        matSuffix
                        (click)="
                          editProductValue(
                            element.id,
                            'close',
                            productValueForm
                          )
                        "
                        class="value-confirm-button"
                      >
                        <mat-icon>check</mat-icon>
                      </button>
                    </mat-form-field>
                  </td>
                </ng-container>
              </form>

              <ng-container matColumnDef="highlighted">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.highlighted" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    (click)="tableButtonHandler(element.id, 'highlightToggle')"
                  >
                    <mat-icon *ngIf="!element.highlighted"
                      >star_outlined</mat-icon
                    >
                    <mat-icon
                      *ngIf="element.highlighted"
                      style="color: darkorange"
                      >star</mat-icon
                    >
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="downloadable">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.donwloadable" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    (click)="tableButtonHandler(element.id, 'downloadToggle')"
                  >
                    <mat-icon *ngIf="!element.downloadable" style="color: gray"
                      >file_download_off</mat-icon
                    >
                    <mat-icon
                      *ngIf="element.downloadable"
                      style="color: #5fbeb5"
                      >download_off</mat-icon
                    >
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="highlighted_reportage">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.highlighted" | translate }}
                  {{ "tables.reportage" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    (click)="
                      tableButtonHandler(
                        element.id,
                        'highlighted_reportageToggle'
                      )
                    "
                  >
                    <mat-icon *ngIf="!element.highlighted_reportage"
                      >collections</mat-icon
                    >
                    <mat-icon
                      *ngIf="element.highlighted_reportage"
                      style="color: darkorange"
                      >collections</mat-icon
                    >
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="min">
                <th mat-header-cell *matHeaderCellDef style="min-width:80px">Min.</th>
                <td mat-cell *matCellDef="let element">
                  <input
                    matInput
                    [value]="element.min"
                    type="number"
                    min="1"
                    max="999"
                    (input)="updateMin(element.id, $event)"
                  />
                </td>
              </ng-container>

              <ng-container matColumnDef="max">
                <th mat-header-cell *matHeaderCellDef style="min-width:80px">Max.</th>
                <td mat-cell *matCellDef="let element">
                  <input
                    matInput
                    [value]="element.max"
                    type="number"
                    min="1"
                    max="999"
                    (input)="updateMax(element.id, $event)"
                  />
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    (click)="tableButtonHandler(element.id, 'delete')"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="selectedProductsListColumns"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: selectedProductsListColumns"
                cdkDrag
                [cdkDragData]="row"
              ></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="6" style="cursor: default">
                  <span *ngIf="showCatalogProductsTableBar">{{
                    "tables.loading" | translate
                  }}</span>
                  <span *ngIf="!showCatalogProductsTableBar">{{
                    "tables.no_data_found" | translate
                  }}</span>
                </td>
              </tr>

              <!-- <tr mat-footer-row *matFooterRowDef="selectedProductsListColumns"></tr> -->
            </table>

            <mat-progress-bar
              *ngIf="showCatalogProductsTableBar"
              mode="indeterminate"
            ></mat-progress-bar>
          </div>

          <div
            *ngIf="showProductListLoadingSpinner && !isList && showProductsGrid"
            class="spinner-wrapper"
          >
            <mat-spinner class="spinner-inner"></mat-spinner>
          </div>

          <!-- PRODUCT SELECTION GRID -->
          <div *ngIf="!isList && showProductsGrid" class="grid">
            <div class="grid-elements">
              <div *ngFor="let item of productsList">
                <div class="grid-element" (click)="productSelectHandler(item)">
                  <div class="item">
                    <div>
                      <img class="grid-image" [src]="item.product_image" />
                    </div>
                    <div class="grid-card-title">
                      <span style="display: {{ 'es' | translate }}">{{
                        item.name_es
                      }}</span>
                      <span style="display: {{ 'en' | translate }}">{{
                        item.name_en
                      }}</span>
                      <span style="display: {{ 'cat' | translate }}">{{
                        item.name_cat
                      }}</span>
                    </div>

                    <div
                      *ngFor="
                        let description of productDescriptionList[item.id]
                      "
                    >
                      <span style="display: {{ 'es' | translate }}"
                        >{{ description.unit ? description.unit : "*" }} &nbsp;
                        {{ description.description_es }}</span
                      >
                      <span style="display: {{ 'en' | translate }}"
                        >{{ description.unit ? description.unit : "*" }} &nbsp;
                        {{ description.description_en }}</span
                      >
                      <span style="display: {{ 'cat' | translate }}"
                        >{{ description.unit ? description.unit : "*" }} &nbsp;
                        {{ description.description_cat }}</span
                      >
                    </div>
                    <hr style="width: 100%" />
                    <div>
                      <p style="font-size: 16px; margin: 0">
                        {{ item.value }}€
                        {{ "tables.vat_included" | translate }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="item-overlay"
                    [ngClass]="{ hide: !item.selected }"
                  >
                    <mat-icon
                      style="font-size: 144px; color: white"
                      [inline]="true"
                      >check</mat-icon
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- BOTON PROVISIONAL QUE SE MUESTRA SI ESTAMOS DENTRO DE LA PARRILLA DE PRODUCTOS PARA VOLVER A LA TABLA DE PRODUCTOS -->
          <div class="float-button-container" style="right: 50px">
            <button
              *ngIf="!isList && showProductsGrid"
              mat-flat-button
              (click)="showProductsGrid = !showProductsGrid"
              class="save-changes-button"
            >
              <mat-icon>arrow_back</mat-icon>
              <span>{{ "buttons.add_products" | translate }}</span>
            </button>
          </div>

          <!-- BOTON QUE GUARDA TODA LA INFORMACIÓN (PRODUCTOS, CATALOGO) Y HACE LLAMADA DE API PARA ACTUALIZAR RELACIÓN. -->
          <div class="float-button-container">
            <button
              mat-fab
              color="primary"
              *ngIf="!isList && !showProductsGrid && !isNew"
              mat-flat-button
              (click)="duplicate? duplicateCatalogue() : saveProductGrid(catalogueForm)"
            >
              <mat-icon>save</mat-icon>
            </button>
          </div>

          <!-- BOTON PARA ENTRAR EN SECCIÓN DE CREAR CATALOGO NUEVO -->
          <div class="float-button-container" *ngIf="isList">
            <button
              mat-fab
              color="primary"
              aria-label="add"
              (click)="newCatalogue()"
            >
              <mat-icon>plus_one</mat-icon>
            </button>
          </div>

          <!-- BOTON PARA GUARDAR CATALOGO RECIÉN CREADO -->
          <div class="float-button-container" *ngIf="!isList && isNew">
            <button
              mat-fab
              color="primary"
              aria-label="save"
              (click)="saveCatalogue()"
            >
              <!-- <mat-icon>save</mat-icon> -->
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
